import { RouteObject } from "react-router-dom";
import Invoice from "@/pages/Moves/Invoice";
import MobilePayment from "@/pages/Moves/MobilePayment";

export const mobileRoutes: RouteObject[] = [
  {
    path: "invoice/move/:id",
    element: <Invoice />,
  },
  {
    path: "payment/move/:id",
    element: <MobilePayment />,
  },
];
